import { BLS_DEFAULTS, FRED_DEFAULTS } from 'constants/econdata';
import * as chartActionTypes from '../../constants/chart-action-types';
import * as econdataActions from '../../actions/econdataActions';
import * as utils from './econdata.utils';

const initialState = {
  mustRender: false,
  ...FRED_DEFAULTS,
  ...BLS_DEFAULTS,
};

function econdataReducer(state = initialState, action) {
  const { payload, stateTree } = action;

  switch (action.type) {
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case econdataActions.MUST_RENDER_FALSE:
      return { ...state, mustRender: payload };
    case chartActionTypes.RECEIVE_CHART:
      return utils.fetchEconDataInfo(state, action);
    case econdataActions.UPDATE_FRED_SERIES:
      return utils.updateChart(stateTree, state, payload, 'fredSeries');
    case econdataActions.UPDATE_FRED_FREQUENCY:
      return utils.updateChart(stateTree, state, payload, 'fredFrequency');
    case econdataActions.UPDATE_FRED_START:
      return utils.updateChart(stateTree, state, payload, 'fredStart');
    case econdataActions.UPDATE_FRED_END:
      return utils.updateChart(stateTree, state, payload, 'fredEnd');
    case econdataActions.UPDATE_FRED_UNITS:
      return utils.updateChart(stateTree, state, payload, 'fredUnits');
    case econdataActions.UPDATE_FRED_MOVING:
      return utils.updateChart(stateTree, state, payload, 'fredMoving');
    case econdataActions.UPDATE_FRED_METHOD:
      return utils.updateChart(stateTree, state, payload, 'fredMethod');
    case econdataActions.UPDATE_BLS_PRESET:
      return utils.updateChart(stateTree, state, payload, 'blsPreset');
    case econdataActions.UPDATE_BLS_SERIES:
      return utils.updateChart(stateTree, state, payload, 'blsSeries');
    case econdataActions.UPDATE_BLS_START:
      return utils.updateChart(stateTree, state, payload, 'blsStart');
    case econdataActions.UPDATE_BLS_END:
      return utils.updateChart(stateTree, state, payload, 'blsEnd');
    case econdataActions.UPDATE_BLS_CALCULATIONS:
      return utils.updateChart(stateTree, state, payload, 'blsCalculations');
    case econdataActions.UPDATE_BLS_MONTHS:
      return utils.updateChart(stateTree, state, payload, 'blsMonths');
    case econdataActions.UPDATE_BLS_MOVING:
      return utils.updateChart(stateTree, state, payload, 'blsMoving');
    case econdataActions.SHOW_BLS_MESSAGE:
      return utils.updateChart(stateTree, state, payload, 'showBLSMessage');
    case econdataActions.UPDATE_BLS_ERROR:
      return utils.updateChart(stateTree, state, payload, 'blsError');
    default:
      return state;
  }
}

export default econdataReducer;
